module.exports = __webpack_public_path__ + "b54500d9503d30109f1a6acdb9fe81d8.woff";